<template>
  <ElTableColumn
    :resizable="false"
    :min-width="150"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'QueryColumn',
  inheritAttrs: false,
};
</script>
